import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ModuleRoute } from "@/components/ModuleRoute";
import { AppShell } from "@/components/AppShell";
import Login from "@/pages/Login";
import ForcePasswordChange from "@/pages/ForcePasswordChange";
import Placeholder from "@/pages/Placeholder";
import Dashboard from "@/pages/Dashboard";
import LocationsList from "@/pages/LocationsList";
import LocationDetail from "@/pages/LocationDetail";
import LocationForm from "@/pages/LocationForm";
import AssetsList from "@/pages/AssetsList";
import AssetDetail from "@/pages/AssetDetail";
import AssetForm from "@/pages/AssetForm";
import RecoverableOverview from "@/pages/RecoverableOverview";
import StoringenList from "@/pages/StoringenList";
import StoringDetail from "@/pages/StoringDetail";
import WerkbonnenList from "@/pages/WerkbonnenList";
import WerkbonnenUitgezet from "@/pages/WerkbonnenUitgezet";
import WerkbonDetail from "@/pages/WerkbonDetail";
import FacturenList from "@/pages/FacturenList";
import FactuurNieuw from "@/pages/FactuurNieuw";
import FactuurDetail from "@/pages/FactuurDetail";
import UrenPage from "@/pages/UrenPage";
import KnowledgeBase from "@/pages/KnowledgeBase";
import KbArticleDetail from "@/pages/KbArticleDetail";
import PartsStock from "@/pages/PartsStock";
import Calendar from "@/pages/Calendar";
import Keuringen from "@/pages/Keuringen";
import MijnWerk from "@/pages/MijnWerk";
import PublicReport from "@/pages/PublicReport";
import ScanLanding from "@/pages/ScanLanding";
import PublicFollow from "@/pages/PublicFollow";
import Settings from "@/pages/Settings";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          {/* Public, no-login QR reporting + follow pages */}
          {/* QR sticker: staff get the machine + actions, anyone else the report form */}
          <Route path="/m/:qrId" element={<ScanLanding />} />
          <Route path="/f/:token" element={<PublicFollow />} />
          <Route
            path="/wachtwoord-wijzigen"
            element={
              <ProtectedRoute>
                <ForcePasswordChange />
              </ProtectedRoute>
            }
          />

          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/assets" element={<AssetsList />} />
            <Route path="/assets/nieuw" element={<AssetForm />} />
            <Route path="/assets/:id" element={<AssetDetail />} />
            <Route path="/assets/:id/bewerken" element={<AssetForm />} />
            <Route path="/storingen" element={<ModuleRoute module="storingen"><StoringenList /></ModuleRoute>} />
            <Route path="/storingen/:id" element={<ModuleRoute module="storingen"><StoringDetail /></ModuleRoute>} />
            <Route path="/werkbonnen" element={<ModuleRoute module="werkbonnen"><WerkbonnenList /></ModuleRoute>} />
            <Route path="/werkbonnen/uitgezet" element={<ModuleRoute module="werkbonnen"><WerkbonnenUitgezet /></ModuleRoute>} />
            <Route path="/werkbonnen/:id" element={<ModuleRoute module="werkbonnen"><WerkbonDetail /></ModuleRoute>} />
            <Route path="/uren" element={<ModuleRoute module="uren"><UrenPage /></ModuleRoute>} />
            <Route path="/facturen" element={<FacturenList />} />
            <Route path="/facturen/nieuw" element={<FactuurNieuw />} />
            <Route path="/facturen/:id" element={<FactuurDetail />} />
            <Route path="/kennisbank" element={<ModuleRoute module="kennisbank"><KnowledgeBase /></ModuleRoute>} />
            <Route path="/kennisbank/:id" element={<ModuleRoute module="kennisbank"><KbArticleDetail /></ModuleRoute>} />
            <Route path="/onderdelen" element={<ModuleRoute module="onderdelen"><PartsStock /></ModuleRoute>} />
            <Route path="/verhaalbaar" element={<ModuleRoute module="verhaalbaar"><RecoverableOverview /></ModuleRoute>} />
            <Route path="/kalender" element={<ModuleRoute module="kalender"><Calendar /></ModuleRoute>} />
            <Route path="/keuringen" element={<ModuleRoute module="keuringen"><Keuringen /></ModuleRoute>} />
            <Route path="/mijn-werk" element={<ModuleRoute module="punten"><MijnWerk /></ModuleRoute>} />
            {/* One copy of the punten list: the old Kalender tab lands on Mijn werk. */}
            <Route path="/kalender/punten" element={<Navigate to="/mijn-werk" replace />} />

            <Route path="/locaties" element={<LocationsList />} />
            <Route path="/locaties/nieuw" element={<LocationForm />} />
            <Route path="/locaties/:id" element={<LocationDetail />} />
            <Route path="/locaties/:id/bewerken" element={<LocationForm />} />

            <Route path="/instellingen" element={<Navigate to="/instellingen/gebruikers" replace />} />
            <Route path="/instellingen/gebruikers" element={<Settings />} />
            <Route path="/instellingen/entiteiten" element={<Settings />} />
            <Route path="/instellingen/categorieen" element={<Settings />} />
            <Route path="/instellingen/oorzaken" element={<Settings />} />
            <Route path="/instellingen/keuringtypes" element={<Settings />} />
            <Route path="/instellingen/demarcatie" element={<Settings />} />
            <Route path="/instellingen/onderhoud" element={<Settings />} />
            <Route path="/instellingen/meekijken" element={<Settings />} />
            <Route path="/instellingen/email" element={<Settings />} />
            <Route path="/instellingen/activiteit" element={<Settings />} />
            <Route path="/instellingen/mcmain" element={<Settings />} />
            <Route path="/instellingen/tarieven" element={<Settings />} />
            <Route path="/instellingen/facturatie" element={<Settings />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;
